const MyLicenseStock = () => {
    return (
        <div>
            <h1>My License Stock</h1>
        </div>
    );
};

export default MyLicenseStock;
